import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddressTypeEnum } from '../../../enum/type/address-type.enum';
import { DateFormatEnum } from '../../../enum/date-format.enum';
import { ModalSizeEnum } from '../../../enum/modal-size.enum';
import { RoleCodeEnum } from '../../../enum/role-code.enum';
import { DynamicTableColumnModel } from '../../../models/dto/core/dynamicTableColumn.model';
import { Address } from '../../../models/entity/address';
import { AddressService } from '../../../services/core/address.service';
import { AlertifyService } from '../../../services/core/alertify.service';
import { CustomerService } from '../../../services/customer/customer.service';
import { AddressAddUpdateComponent } from '../address-add-update/address-add-update.component';
import { ArrayUtils } from '../../../utils/array.utils';
import { GeneralUtils } from '../../../utils/general.utils';


@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.css']
})
export class AddressListComponent implements OnInit {
  @Input() customerId: number;
  @Input() hideContactAddress: boolean = false;
  @Input() showSelectButton: boolean = true;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  dataList: Address[] = [];
  cols: DynamicTableColumnModel[];
  data: Address = new Address();

  isNewData: boolean;
  loading: boolean;

  dateFormatEnum = DateFormatEnum;
  roleCodeEnum = RoleCodeEnum;
  contactAddress: Address;

  constructor(
    private customerService: CustomerService,
    private addressService: AddressService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private alertifyService: AlertifyService
  ) { }
  ngOnInit() {
    this.getData();
    this.getCols();
  }

  // listeler
  getData() {
    if (!this.customerId || this.customerId <= 0)
      return;

    this.loading = true;
    this.customerService.getCustomerAddresses(this.customerId).subscribe(
      (res) => {
        this.dataList = res;
        this.contactAddress = this.dataList.filter(x => x.addressTypeId == AddressTypeEnum.CONTACT)[0];
        if (this.hideContactAddress)
          this.dataList = this.dataList.filter(x => x.addressTypeId != AddressTypeEnum.CONTACT);
        this.loading = false;
      },
      (err) => {
        this.alertifyService.error(err);
        this.loading = false;
      }
    );
  }

  selectAddress(rowData) {
    this.passEntry.emit(rowData);
  }

  // Modal ekleme güncelleme
  openAddUpdateModal(rowData) {
    const modalRef = this.modalService.open(AddressAddUpdateComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE
    });

    // eğer güncelleme ise bu değer dolu geliyor
    if (rowData) {
      this.isNewData = false;
      this.data = rowData;
    }
    else {
      this.isNewData = true;
      this.data = new Address();
      this.data.addressTypeId = AddressTypeEnum.ORDER;
      this.data.customerId = this.customerId;
      if (this.contactAddress != null) {
        this.data.countryId = this.contactAddress.countryId;
        this.data.countryName = this.contactAddress.countryName;
        this.data.cityId = this.contactAddress.cityId;
        this.data.cityName = this.contactAddress.cityName;
        this.data.subProvinceId = this.contactAddress.subProvinceId;
        this.data.subProvinceName = this.contactAddress.subProvinceName;
        this.data.districtId = this.contactAddress.districtId;
        this.data.districtName = this.contactAddress.districtName;

      }
    }

    //modal  veri geçişi
    modalRef.componentInstance.data = GeneralUtils.clone(this.data);

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      // Cevap boş değilse
      if (receivedEntry) {

        if (this.isNewData)
          this.dataList = this.dataList.concat(receivedEntry);
        else {
          ArrayUtils.replace(this.dataList, this.data, receivedEntry);
          this.dataList = this.dataList.slice();
        }
        this.data = receivedEntry;
      }

      // modal kapat
      modalRef.close();
    });

  }


  //sil
  delete(rowData) {
    this.addressService
      .deleteAddress(rowData.id)
      .subscribe(
        (res) => {
          ArrayUtils.remove(this.dataList, rowData);
          this.dataList = this.dataList.slice();
          this.alertifyService.success(this.translate.instant('message.info.deleted'));
        },
        (err) => {
          this.alertifyService.error(err);
        }
      );
  }

  close() {
    this.passEntry.emit();
  }

  //tablo alanları
  private getCols() {
    this.cols = [
      {
        field: "title",
        header: this.translate.instant('address.title')
      },
      // {
      //   field: "cityName",
      //   header: this.translate.instant('address.city')
      // },
      // {
      //   field: "subProvinceName",
      //   header: this.translate.instant('address.subProvince')
      // },
      // {
      //   field: "districtName",
      //   header: this.translate.instant('address.district')
      // },
      {
        field: "description",
        header: this.translate.instant('address.description')
      },
      {
        field: "siteName",
        header: this.translate.instant('address.siteName')
      },
      {
        field: "buildingName",
        header: this.translate.instant('address.buildingName')
      },
      {
        field: "doorNum",
        header: this.translate.instant('address.doorNum')
      }
    ];
  }
}
